import { render, staticRenderFns } from "./HelpMenuEdit.vue?vue&type=template&id=a8dcc2f4&scoped=true"
import script from "./HelpMenuEdit.vue?vue&type=script&lang=js"
export * from "./HelpMenuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dcc2f4",
  null
  
)

export default component.exports